import getCheckoutOrderManager from './getCheckoutOrderManager';
import { CartUpdateOptions, CartOrderItem } from 'cart-core';

/**
 * @param items the order items to add
 * @param options
 */
export default async function addToCart(
    items: CartOrderItem[],
    options: CartUpdateOptions
) {
    const mgr = await getCheckoutOrderManager();
    await mgr.addItems(items, options);
}
